import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {


  public isTW: boolean;
  public isAcicOnly:boolean;
  public isMa: boolean;
  public isAs400Only = false;
  currentCompany = "";
  public company = new BehaviorSubject<any>(this.currentCompany);
  $currentCompany = this.company.asObservable();
  public hasGWPolicy = false;
  getCompany(){
    if (this.isMa && (this.isTW || this.isAcicOnly))  {
      this.updateCompanyDetails("all")
    } else if (this.isMa){
      this.updateCompanyDetails("ma")
    } else if (!this.isMa && this.isTW) {
      this.updateCompanyDetails("tw")
    } else if (!this.isMa && !this.isTW && this.isAcicOnly){
      this.updateCompanyDetails("acic")
    } else if (!this.isMa && !this.isTW && !this.isAcicOnly && this.isAs400Only) {
      this.updateCompanyDetails("as400")
     } else if (this.isAcicOnly || this.isTW) {
      this.updateCompanyDetails("legacy")
    } else {
      this.updateCompanyDetails("ma")
    }
  }

  updateCompanyDetails(companyDetails: any) {
    this.company.next(companyDetails);
  }

  clearCompanyDetails() {
    this.company.next('');
    this.isTW = false;
    this.isAcicOnly = false;
    this.isMa = false;
    this.isAs400Only = false;
    this.hasGWPolicy = false;
  }


}
